// First, so no other module logs before production silences the console.
import './utils/productionConsole';
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { installGlobalErrorHandlers } from './utils/errorReporting';

// Before render, so errors thrown during the first mount are captured too.
installGlobalErrorHandlers();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Registers LCP, INP, CLS, FCP and TTFB. Pass a handler to route the metrics
// somewhere other than the console - see reportWebVitals.ts.
reportWebVitals();

// Real-user traces for page load and every callable round trip. Loaded in its
// own chunk after render so it never competes with first paint, and skipped in
// development so local runs don't pollute production percentiles.
if (process.env.NODE_ENV === 'production') {
  import('./performance').then(({ initPerformance }) => initPerformance());
}
